import {ICompanyDetailsDTO, ICompanyDetails} from "./dto/ICompanyDetails";
import {BaseModel} from "../../model/shared/BaseModel";
import {COMPANY_URL} from "../../utils/helpers/api.routes";
import {requests} from "../../utils/helpers/api.services";

export const CompanyDetailsService = {
    getMyCompanyDetails: (): Promise<BaseModel<ICompanyDetails>> => requests.get(`${COMPANY_URL}/details`),
    updateClientDetails: (params: ICompanyDetailsDTO) => requests.put(`${COMPANY_URL}/admin-update-company`, params)
}